'use client';

// A navigation link that looks like a Button. Wrapping a Button in a Link puts
// a <button> inside an <a> — invalid HTML (two nested interactive elements, two
// tab stops, the button swallowing keyboard activation in some browsers). Use
// this instead whenever a "button" only goes somewhere.

import Link from 'next/link';
import { forwardRef } from 'react';
import { buttonClasses, type ButtonSize, type ButtonVariant } from './Button';

interface ButtonLinkProps extends Omit<React.ComponentProps<typeof Link>, 'className'> {
  id: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  className?: string;
}

export const ButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  ({ variant = 'primary', size = 'md', fullWidth, leftIcon, rightIcon, className, children, ...props }, ref) => (
    <Link ref={ref} className={buttonClasses({ variant, size, fullWidth, className })} {...props}>
      {leftIcon}
      {children}
      {rightIcon}
    </Link>
  ),
);
ButtonLink.displayName = 'ButtonLink';
